import { __spreadArray, __awaiter, __generator } from 'tslib';
import { useState, useEffect, useCallback } from 'react';

var useTreeFieldState = function (_a) {
    var values = _a.values, onChange = _a.onChange, multiple = _a.multiple, getOptions = _a.getOptions;
    var _b = useState(values), selectedOptions = _b[0], setSelectedOptions = _b[1];
    var _c = useState([]), expandedOptions = _c[0], setExpandedOptions = _c[1];
    useEffect(function () {
        // In case of props update
        setSelectedOptions(values);
    }, [values]);
    var isOptionSelected = useCallback(function (nodeId) { return selectedOptions.some(function (t) { return t.id === nodeId; }); }, [selectedOptions]);
    var isOptionExpanded = useCallback(function (nodeId) { return expandedOptions.some(function (t) { return t === nodeId; }); }, [expandedOptions]);
    var handleExpand = function (nodeId) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (isOptionExpanded(nodeId)) {
                setExpandedOptions(function (old) { return __spreadArray([], old.filter(function (t) { return t !== nodeId; }), true); });
            }
            else {
                setExpandedOptions(function (old) { return __spreadArray(__spreadArray([], old, true), [nodeId], false); });
            }
            getOptions && getOptions(nodeId);
            return [2 /*return*/];
        });
    }); };
    var handleSelectOption = useCallback(function (option) {
        setSelectedOptions(function (old) {
            var selected;
            if (multiple) {
                if (isOptionSelected(option.id)) {
                    selected = __spreadArray([], old.filter(function (t) { return t.id !== option.id; }), true);
                }
                else {
                    selected = __spreadArray(__spreadArray([], old, true), [option], false);
                }
            }
            else {
                selected = [option];
            }
            onChange(selected);
            return selected;
        });
    }, [isOptionSelected, multiple, onChange]);
    return {
        selectedOptions: selectedOptions,
        setSelectedOptions: setSelectedOptions,
        expandedOptions: expandedOptions,
        setExpandedOptions: setExpandedOptions,
        isOptionSelected: isOptionSelected,
        isOptionExpanded: isOptionExpanded,
        handleExpand: handleExpand,
        handleSelectOption: handleSelectOption
    };
};

export { useTreeFieldState };
//# sourceMappingURL=hooks.js.map
